export default {
    meta: {
        title: 'Iframe 页面'
    }
};
